export const BACKEND_URL = 'https://speakout-bff-gt2qqdnodq-uc.a.run.app';
export const SHOPIFY_TOKENS = {
  domain: 'speakout7eleven.ca',
  storefrontAccessToken: 'eda15b11e1ca7da553e8dcd64946b90e'
}
export const environment = {
  production: false,
};
export const PRODUCT = 'SPEAKOUT';
export const GOOGLE_API_KEY = 'AIzaSyANCkAejnaho2QVphlYvqZ-bVA5FV8j-FI';
export const CORE_CLIENT = 'zBOgQC0r9vm5';
export const CORE_SECRET = 'qxBtCdVxkPxI2kqd6cnr88Jf';
export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyD0sskh3-3LD7nmbLXg83hWfSYDpuJtJNA",
  authDomain: "ztar-product-g2g-ca-test.firebaseapp.com",
  databaseURL: "https://ztar-product-g2g-ca-test-default-rtdb.firebaseio.com",
  projectId: "ztar-product-g2g-ca-test",
  storageBucket: "ztar-product-g2g-ca-test.firebasestorage.app",
  messagingSenderId: "911965603431",
  appId: "1:911965603431:web:827aaa4785f78f1a7f76c2"
};
export const BFF_URL = "https://speakout-bff-gt2qqdnodq-uc.a.run.app"